import axios from 'axios';
import { useEffect, useMemo } from 'react';
import { createRequestHook } from '@clover-util/use-request';
import { getHeapUserId } from 'util/Analytics';
import { HOSTNAME, SERVER_PATH } from 'olo-service/axiosInstance';

export function useColoAxiosInstance() {
  const heapId = getHeapUserId();

  const instance = useMemo(() => {
    return axios.create({
      baseURL: `${HOSTNAME}/${SERVER_PATH}`,
    });
  }, []);

  useEffect(() => {
    if (!heapId) return;
    instance
      .interceptors
      .request
      .use((config) => ({
        ...config,
        headers: {
          ...config.headers,
          'X-Tracking-Id': `HEAP:${heapId}`
        }
      }));
  }, [heapId, instance]);

  return instance;
}

export const useColoRequest = createRequestHook(useColoAxiosInstance);
